module.exports = __webpack_public_path__ + "static/media/500.3a320474.svg";